<template>
  <div class="content">
    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">

        <b-col lg="12">

          <template v-if="!evb.is_company">
            <button class="btn btn-primary" @click="toggleEvbCompany()">
              <i class="fa fa-user"></i>
              Privatkunde
            </button>
            <button class="btn" @click="toggleEvbCompany()">
              <i class="fa fa-university"></i>
              Geschäftskunde
            </button>
          </template>

          <template v-if="evb.is_company">
            <button class="btn" @click="toggleEvbCompany()">
              <i class="fa fa-user"></i>
              Privatkunde
            </button>
            <button class="btn btn-primary" @click="toggleEvbCompany()">
              <i class="fa fa-university"></i>
              Geschäftskunde
            </button>
          </template>

        </b-col>

      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row class="card-wrapper">
        <b-col lg="6" id="main">
          <b-row class="card-wrapper">
            <b-col lg="12">
              <card>
                <!-- Card header -->

                <b-row align-v="center" slot="header">
                  <b-col cols="8">
                    <h3 slot="header" class="mb-0">
                      <i class="fa fa-id-card"></i>
                      Evb anfordern
                    </h3>
                  </b-col>
                </b-row>


                <!-- Card body -->
                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                    <evbWrapper>

                      <b-row>
                        <b-col md="6" v-if="!evb.is_company">
                          <h4>Anrede</h4>
                          <base-input prepend-icon="fas fa-calendar" v-model="evb.title" type="text" name="Anrede"
                            placeholder="Anrede">
                          </base-input>
                        </b-col>

                        <b-col md="6" v-if="!evb.is_company">
                          <h4>Vorname</h4>
                          <base-input prepend-icon="fas fa-calendar" v-model="evb.firstname" type="text" name="Vorname"
                            placeholder="Vorname">
                          </base-input>
                        </b-col>

                        <b-col md="6" v-if="!evb.is_company">
                          <h4>Nachname</h4>
                          <base-input prepend-icon="fas fa-calendar" v-model="evb.lastname" type="text" name="Nachname"
                            placeholder="Nachname">
                          </base-input>
                        </b-col>

                        <b-col md="6" v-if="evb.is_company">
                          <h4>Firmenname</h4>
                          <base-input prepend-icon="fas fa-calendar" v-model="evb.company_name" type="text"
                            name="Firmenname" placeholder="Firmenname">
                          </base-input>
                        </b-col>
                      </b-row>


                      <b-row>

                        <b-col md="6" v-if="!evb.is_company">
                          <h4>Geburtsdatum</h4>
                          <!-- csc-date-input v-model="evb.dob"/ -->
                          <base-input prepend-icon="fas fa-calendar" v-model="evb.dob" type="date" name="Geburtsdatum"
                            rules="required" placeholder="DD.MM.YYYY">
                          </base-input>
                        </b-col>
                      </b-row>



                      <b-row>


                        <template>
                          <b-col md="12">
                            <b-row>

                              <b-col md="6">
                                <h4>PLZ</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="PLZ" v-model="evb.zip"
                                  name="PLZ" rules="required"></base-input>
                              </b-col>

                              <b-col md="6">
                                <h4>Ort</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Ort" v-model="evb.city"
                                  name="Ort" rules="required"></base-input>
                              </b-col>

                            </b-row>
                            <b-row>
                              <b-col md="6">
                                <h4>Strasse & Hausnummer</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Strasse"
                                  v-model="evb.street" name="Strasse" rules="required"></base-input>
                              </b-col>


                              <b-col md="6" v-if="!evb.is_company">
                                <h4>Nationalität</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Nationalität"
                                  v-model="evb.nationality" name="Nationalität" rules="required"></base-input>



                              </b-col>

                            </b-row>


                            <b-row>
                        <b-col md="6">
                          <h4>Abweichender Halter:</h4>

                          <b-form-radio-group v-model="evb.has_holder" v-on:change="changeHasHolder">
                            <div>
                              <b-form-radio value="1" name="unchecked" class="mb-3">
                                Ja
                              </b-form-radio>
                              <b-form-radio value="0" name="checked" class="mb-3">
                                Nein
                              </b-form-radio>
                            </div>
                          </b-form-radio-group>
                        </b-col>
                      </b-row>



                          </b-col>
                        </template>


                        <template v-if="evb.has_holder == 1">
                          <b-col md="12">
                            <h4>Bitte daten des abweichenden Halter angeben:</h4>


                            <b-row>

                              <b-col md="6">
                                <h4>Vorname</h4>
                                <base-input prepend-icon="fas fa-calendar" v-model="evb.holder_firstname" type="text"
                                  name="Vorname" placeholder="Vorname">
                                </base-input>
                              </b-col>

                              <b-col md="6">
                                <h4>Nachname</h4>
                                <base-input prepend-icon="fas fa-calendar" v-model="evb.holder_lastname" type="text"
                                  name="Nachname" placeholder="Nachname">
                                </base-input>
                              </b-col>

                              <b-col md="6">
                                <h4>PLZ</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="PLZ"
                                  v-model="evb.holder_zip" name="PLZ" rules="required"></base-input>
                              </b-col>

                              <b-col md="6">
                                <h4>Ort</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Ort" v-model="evb.holder_city"
                                  name="Ort" rules="required"></base-input>
                              </b-col>

                            </b-row>
                            <b-row>
                              <b-col md="6">
                                <h4>Strasse & Hausnummer</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Strasse"
                                  v-model="evb.holder_street" name="Strasse" rules="required"></base-input>
                              </b-col>


                              <b-col md="6" v-if="!evb.is_company">
                                <h4>Nationalität</h4>
                                <base-input prepend-icon="fas fa-map-marker" placeholder="Nationalität"
                                  v-model="evb.nationality" name="Nationalität" rules="required"></base-input>



                              </b-col>

                            </b-row>


                          </b-col>
                        </template>


                      </b-row>

                    </evbWrapper>

                  </form>
                </validation-observer>
              </card>
            </b-col>
          </b-row>


        </b-col>


        <b-col lg="12">
          <base-button type="primary" class="btn btn-primary" @click="submitToApi()" v-if="true">Jetzt
            anfordern</base-button>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import BaseSlider from "@/components/BaseSlider";
import { Modal, BaseAlert } from "@/components";
import swal from "sweetalert2";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

//import dateUtil from 
import dateUtil from "../../services/date";

import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    RouteBreadCrumb,
    BaseSlider,
    Modal,
  },
  data() {
    return {
      loading: false,
      //token: false,
      evbData: [],
    };
  },
  props: {
    token: String,
    title: "Evb anfordern",
    icon: "fa-user",
  },
  methods: {
    // send via apollo
    submitToApi() {
      this.loading = true;
      this.$api
        .createEvb(this.evb)
        .then((response) => {
          console.log(this.evb);
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', "EVB.pdf");
        link.click()
        URL.revokeObjectURL(link.href)
        
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setDefaults() {
      this.edtload = true;
      this.$store.dispatch("resetEvb");

      var date = new Date();

      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var day = ('0' + date.getDate()).slice(-2);
      var year = date.getFullYear();

      var htmlDate = year + '-' + month + '-' + day;
      console.log("THEDATE: " + htmlDate);

      if (!this.$sidebar.isMinimized) {
        this.$sidebar.toggleMinimize();
      }
      this.edtload = false;

    },
    toggleHolder: function () {
      this.showHolder = !this.showHolder;
    },
    toggleEvbCompany() {
      if (this.evb.is_company) {
        this.evb.is_company = false;
      } else {
        this.evb.is_company = true;
      }

    },
    toggleEvbHolder() {
      if (this.evb.has_holder) {
        this.evb.has_holder = false;
      } else {
        this.evb.has_holder = true;
      }

    },

  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      evb: (state) => state.evb,
    }),
    ...mapActions({
      resetEvb: (state) => state.resetEvb,
    }),
    has_holder: (state) => state.evb.has_holder,
    holder: (state) => state.evb.holder_id,
  },

  watch: {
    '$route'(to, from) {
      this.setDefaults();
    },
    holder(newValue, oldValue) {
      console.log(`Updating from ${oldValue} to ${newValue}`);
      this.currentHolder();
      // this.toggleHolder();
      // Do whatever makes sense now
      if (newValue === "success") {
        this.complex = {
          deep: "some deep object",
        };
      }
      if (newValue != "N") {
        //   this.offer.has_holder = true;
      } else {
        //   this.offer.has_holder = false;
        this.offer.holder_kravag_location_id = "";
      }
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      console.log(`Updating to ${state}`);
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style>
.spinner {
  width: 40px;
  height: 40px;

  margin: 100px auto;
  z-index: 10000000;
  /*  display: none;*/

  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;

}

.double-bounce1,
.double-bounce2 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 50%;
  left: 50%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {

  0%,
  100% {
    -webkit-transform: scale(0.0)
  }

  50% {
    -webkit-transform: scale(1.0)
  }
}

@keyframes sk-bounce {

  0%,
  100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }

  50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>